export enum FORM_FIELDS_NAMES {
  TYPE = 'type',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  MIDDLE_NAME = 'middleName',
  TIN = 'tin',
  NAME = 'name',
  ZIP_CODE = 'zipCode',
  EDRPOU = 'edrpou',
  CITY = 'city',
  STREET = 'street',
  BUILDING = 'building',
  APPARTMENT = 'apartment',
  EXTRAS = 'extras',
}
